import NetworkManager from './NetworkManager';

export const RESPONDENT_ERRORS_PATH = '/respondent-errors';

export type TRespondentErrorSurface = 'render' | 'submit' | 'auth' | 'unknown';

export interface IRespondentError {
  id: string;
  brandId: string;
  formId?: string;
  linkId?: string;
  userId?: string;
  yumId?: string;
  environment: string;
  surface: TRespondentErrorSurface;
  statusCode?: number;
  errorCode?: string;
  message: string;
  requestUrl?: string;
  pageUrl?: string;
  userAgent?: string;
  timestamp: string;
}

export interface IRespondentErrorSummary {
  total24h: number;
  byStatusCode: Record<string, number>;
  bySurface: Record<string, number>;
  topMessages: Array<{ message: string; count: number }>;
}

export interface IRespondentErrorPage {
  items: IRespondentError[];
  nextToken?: string;
  summary: IRespondentErrorSummary;
}

export interface IReportRespondentErrorInput {
  formId?: string;
  linkId?: string;
  surface: TRespondentErrorSurface;
  statusCode?: number;
  errorCode?: string;
  message: string;
  requestUrl?: string;
  pageUrl?: string;
}

interface IApiResponse<T> {
  status: boolean;
  data: T;
}

export async function reportRespondentError(input: IReportRespondentErrorInput): Promise<void> {
  await NetworkManager.post<IApiResponse<{ recorded: boolean }>>(RESPONDENT_ERRORS_PATH, {
    ...input,
    pageUrl: input.pageUrl ?? `${window.location.pathname}${window.location.search}`,
    userAgent: navigator.userAgent,
  });
}

export async function listRespondentErrors(params?: {
  nextToken?: string;
  pageSize?: number;
}): Promise<IRespondentErrorPage> {
  const query: Record<string, unknown> = {};
  if (params?.nextToken) query.nextToken = params.nextToken;
  if (params?.pageSize) query.pageSize = params.pageSize;

  const res = await NetworkManager.get<IApiResponse<IRespondentErrorPage>>(
    RESPONDENT_ERRORS_PATH,
    query,
  );
  return res.data;
}
